import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';

export default function ContactPage() {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="contact-page">
      <section className="py-24 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-[#C5A059] text-xs uppercase tracking-[0.3em] font-medium">{t('contact.title')}</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F3F4F6] mt-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{t('contact.subtitle')}</h1>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Sol: İletişim Bilgileri */}
            <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} className="space-y-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#C5A059]/10 rounded-sm flex items-center justify-center flex-shrink-0"><MapPin className="h-5 w-5 text-[#C5A059]" /></div>
                  <div>
                    <h4 className="text-[#F3F4F6] text-sm font-medium mb-1">{language === 'tr' ? 'Adres' : 'Address'}</h4>
                    <p className="text-[#A1A1AA] text-sm">{t('contact.address')}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#C5A059]/10 rounded-sm flex items-center justify-center flex-shrink-0"><Phone className="h-5 w-5 text-[#C5A059]" /></div>
                  <div>
                    <h4 className="text-[#F3F4F6] text-sm font-medium mb-1">{language === 'tr' ? 'Telefon' : 'Phone'}</h4>
                    <a href="tel:+905063859352" className="text-[#A1A1AA] text-sm hover:text-[#C5A059] transition-colors">{t('contact.phone_number')}</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#C5A059]/10 rounded-sm flex items-center justify-center flex-shrink-0"><Mail className="h-5 w-5 text-[#C5A059]" /></div>
                  <div>
                    <h4 className="text-[#F3F4F6] text-sm font-medium mb-1">E-posta</h4>
                    <a href="mailto:av.sametozturk1@gmail.com" className="text-[#A1A1AA] text-sm hover:text-[#C5A059] transition-colors">{t('contact.email_address')}</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#25D366]/10 rounded-sm flex items-center justify-center flex-shrink-0"><MessageCircle className="h-5 w-5 text-[#25D366]" /></div>
                  <div>
                    <h4 className="text-[#F3F4F6] text-sm font-medium mb-1">WhatsApp</h4>
                    <a href="https://wa.me/905063859352" target="_blank" rel="noopener noreferrer" className="text-[#A1A1AA] text-sm hover:text-[#25D366] transition-colors">{language === 'tr' ? 'WhatsApp ile iletişime geçin' : 'Contact via WhatsApp'}</a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Sağ: Harita */}
            <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }}>
              <div className="rounded-sm overflow-hidden border border-white/10 h-full min-h-[400px]" data-testid="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2976.5!2d37.8833!3d41.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDAwJzAwLjAiTiAzN8KwNTMnMDAuMCJF!5e0!3m2!1str!2str!4v1"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '400px', filter: 'invert(90%) hue-rotate(180deg) brightness(0.9) contrast(0.9)' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Öztürk Hukuk Bürosu Konum"
                />
              </div>
              <div className="p-3 bg-[#121212] border border-white/10 border-t-0 rounded-b-sm">
                <p className="text-[#A1A1AA] text-xs">{t('contact.address')}</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
